var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconInfoCupom = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8710",
    "data-name": "Grupo 8710",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_35",
    "data-name": "Elipse 35",
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#fff",
    stroke: "#173a6d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2190",
    "data-name": "Caminho 2190",
    d: "M4.393,8.693a4.663,4.663,0,0,1-2.336,2.273c-.429.094-.829-.154-.812-1.443L1.268,5.5c0-.385-.035-.526-.135-.506a3.87,3.87,0,0,0-.823.76L0,5.388a5.643,5.643,0,0,1,2.454-2.28c.477-.1.7.418.681,1.537L3.062,8.6c-.014.469.083.583.18.562a2.474,2.474,0,0,0,.8-.79ZM2.9.758A1.167,1.167,0,0,1,1.991,2.2.869.869,0,0,1,.916,1.5,1.188,1.188,0,0,1,1.8.028.894.894,0,0,1,2.9.758Z",
    transform: "translate(6.867 3.706)",
    fill: "#173a6d"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconInfoCupom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_info_cupom.d46b6e59.svg";
export { ForwardRef as ReactComponent };